import { useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { getSEOLanguage } from '../utils/seoHelpers';

// Importar las traducciones directamente para SEO
import esTranslations from '../locales/es.json';
import caTranslations from '../locales/ca.json';

const translations = {
    es: esTranslations,
    ca: caTranslations
};

/**
 * Hook personalizado para establecer el título de la página con lógica SEO
 * Lógica: EN o CA → usa catalán para SEO | ES → usa español para SEO
 *
 * @param {string} pageKey - Clave de la página en meta.pages (ej: 'home', 'about')
 * @param {string} customTitle - Título personalizado opcional (opcional)
 */
const usePageTitle = (pageKey, customTitle = null) => {
    const { language } = useLanguage();

    useEffect(() => {
        // Determinar el idioma SEO según la lógica
        const seoLanguage = getSEOLanguage(language);
        const seoTranslations = translations[seoLanguage];

        if (customTitle) {
            document.title = customTitle;
        } else if (pageKey) {
            // Obtener el título desde las traducciones del idioma SEO
            const keys = `meta.pages.${pageKey}`.split('.');
            let value = seoTranslations;

            for (const k of keys) {
                if (value && typeof value === 'object' && k in value) {
                    value = value[k];
                } else {
                    value = null;
                    break;
                }
            }

            document.title = value || seoTranslations.meta.title;
        } else {
            // Título por defecto
            document.title = seoTranslations.meta.title;
        }
    }, [language, pageKey, customTitle]);
};

export default usePageTitle;
